"use strict";

var _classCallCheck = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MosaicAlias = void 0;

var Alias_1 = require("./Alias");

var AliasType_1 = require("./AliasType");
/**
 * The MosaicAlias structure describe mosaic aliases
 *
 * @since 0.10.2
 */


var MosaicAlias = /*#__PURE__*/function (_Alias_1$Alias) {
  _inherits(MosaicAlias, _Alias_1$Alias);

  var _super = _createSuper(MosaicAlias);

  /**
   * Create AddressAlias object
   * @param mosaicId
   */
  function MosaicAlias(
  /**
   * The alias address
   */
  mosaicId) {
    var _this;

    _classCallCheck(this, MosaicAlias);

    _this = _super.call(this, AliasType_1.AliasType.Mosaic, undefined, mosaicId);
    _this.mosaicId = mosaicId;
    return _this;
  }
  /**
   * Compares AddressAlias for equality.
   *
   * @return boolean
   */


  _createClass(MosaicAlias, [{
    key: "equals",
    value: function equals(alias) {
      return alias && alias.type === this.type && this.mosaicId.equals(alias.mosaicId);
    }
    /**
     * Get string value of mosaicId
     * @returns {string}
     */

  }, {
    key: "toHex",
    value: function toHex() {
      return this.mosaicId.toHex();
    }
  }]);

  return MosaicAlias;
}(Alias_1.Alias);

exports.MosaicAlias = MosaicAlias;